import React from 'react';
import Header from '../../components/header';
import {Trans} from 'react-i18next';
import './index.css';
import {solutionUtils} from '../../../../utils/solutionUtils';
import {history} from '../../../../utils/redux/store';
import {useSelector} from 'react-redux';
import smbUtils from '../../../../utils/smbUtils';
import {privilegeUtils} from '../../../../utils/privilegeUtils';

export default function Menu() {
  const {isSkinAnalysis, isSimulation} = solutionUtils;
  const auth = useSelector(state => state.components.auth.accountSummary);
  const isCnSite = smbUtils.isCnSite(auth);

  const menus = [
    {
      show: true,
      title: <Trans i18nKey="p.generalsettings.title">General Settings</Trans>,
      desc: (
        <Trans i18nKey="p.s.uiconfiguration.munu.common.desc">
          Manage settings and components that will be used across multiple pages
          on App.
        </Trans>
      ),
      items: [
        {
          image: smbUtils.isCnSite(auth)
            ? require('../../../../assets/images/skincare/uiconfigurationmenu/1_CN.png')
            : require('../../../../assets/images/skincare/uiconfigurationmenu/1.jpg'),
          title: (
            <Trans i18nKey="p.s.uiconfiguration.tabs.common.settings">
              Common Settings
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.commonsettings.desc">
              Config header, theme color, and other common settings applied
              across the app.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/common-settings',
        },
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/2.Naming-Preferences.png'),
          title: (
            <Trans i18nKey="p.s.app.settings.title">Name Preferences</Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.app.settings.desc">
              Config naming for items used throughout the app, such as brand
              names, skin concerns, and simulation treatments.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/name-preferences',
        },
        {
          image: smbUtils.isCnSite(auth)
            ? require('../../../../assets/images/skincare/uiconfigurationmenu/2_CN.PNG')
            : require('../../../../assets/images/skincare/uiconfigurationmenu/2.jpg'),
          title: (
            <Trans i18nKey="p.s.uiconfiguration.landingpage.title">
              Landing Page
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.landingpage.desc">
              Config background images and manage language selector options.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/landing',
        },
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/9.png'),
          title: (
            <Trans i18nKey="p.s.c.customization.user.consent">
              User Consent
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.userconsent.desc">
              Config the content of the user consent displayed to clients before
              the photo-taking step.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/user-consent',
        },
      ],
    },
    {
      show: true,
      title: (
        <Trans i18nKey="c.l.sidebar.1150.skincarepro.title">Survey Form</Trans>
      ),
      desc: (
        <Trans i18nKey="p.s.uiconfiguration.munu.survey.form.desc">
          Manage display settings and components for Survey Form pages.
        </Trans>
      ),
      items: [
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/8.png'),
          title: (
            <Trans i18nKey="c.l.sidebar.1150.skincarepro.title">
              Survey Form
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.surveyform.desc">
              Config background image for survey form pages.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/survey-form',
        },
      ],
    },
    {
      show: isSkinAnalysis(auth),
      title: (
        <Trans i18nKey="p.w.r.overview.skin.analysis.title">
          Skin Analysis
        </Trans>
      ),
      desc: (
        <Trans i18nKey="p.s.uiconfiguration.menu.common.desc">
          Manage display settings and components for the Skin Analysis process.
        </Trans>
      ),
      items: [
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/4_Hd.png'),
          title: (
            <Trans i18nKey="p.s.uiconfiguration.tabs.skincaredetection">
              Skincare Detection
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.skincaredetection.desc">
              Config skin type, skin concerns and detection results.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/skincare-detection',
        },
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/4.jpg'),
          title: (
            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skingetresult.title">
              Skin Result Page & Get Skin Result Page
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skingetresult.desc">
              Config the content and layout of skin reports for clients.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/skin-result',
        },
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/10.jpg'),
          title: (
            <Trans i18nKey="p.s.uiconfiguration.sharedskinresultpage.title">
              Shared Skin Result Page
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.sharedskinresultpage.desc">
              Config the skin report that clients can share via QR code, email,
              or printout.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/shared-skin-result-page',
        },
      ],
    },
    {
      show: isSimulation(auth) && !isCnSite,
      title: (
        <Trans i18nKey="u.s.skincare.aesthetic.simulation">
          Aesthetic Simulation
        </Trans>
      ),
      desc: (
        <Trans i18nKey="p.s.uiconfiguration.menu.aesthetic.simulation.desc">
          Manage display settings and components for the Aesthetic Simulation
          process.
        </Trans>
      ),
      items: [
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/5.jpg'),
          title: (
            <Trans i18nKey="p.s.uiconfiguration.simulation.page">
              Simulation Page
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.simulationpage.desc">
              Config simulation categories and treatment options.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/simulation-page',
        },
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/7.png'),
          title: (
            <Trans i18nKey="p.s.uiconfiguration.face.assessment.page">
              Face Assessment Page
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.face.assessment.page.desc">
              Config face assessment categories.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/face-assessment',
        },
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/6.jpg'),
          title: (
            <Trans i18nKey="p.s.uiconfiguration.simulationresultpage.getsimulationresult.title">
              Simulation Report Page & Get Simulation Report Page
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.simulationresultpage.getsimulationresult.desc">
              Config the content and layout of simulation reports for clients.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/simulation-report',
        },
        {
          image: require('../../../../assets/images/skincare/uiconfigurationmenu/11.jpg'),
          title: (
            <Trans i18nKey="p.s.uiconfiguration.sharedsimulationreportpage.title">
              Shared Simulation Report Page
            </Trans>
          ),
          desc: (
            <Trans i18nKey="p.s.uiconfiguration.sharedsimulationreportpage.desc">
              Config the simulation report that clients can share via QR code,
              email, or printout.
            </Trans>
          ),
          link: '/skincare-pro/ui-configuration/shared-simulation-report-page',
        },
      ],
    },
  ];

  if (
    !(
      privilegeUtils.canUiConfig(auth) ||
      privilegeUtils.isTechnicalSupport(auth)
    )
  ) {
    history.push('/');
  }

  return (
    <div className="skincare-configuration-menu-layout">
      <Header publishStatus={null} type="menu" />
      <div className="skincare-configuration-menu-cards">
        {menus.map(
          r =>
            r.show && (
              <div className="skincare-configuration-menu-block">
                <div className="skincare-configuration-menu-block-title">
                  {r.title}
                </div>
                <div className="skincare-configuration-menu-block-desc">
                  {r.desc}
                </div>
                <div className="skincare-configuration-menu-block-items">
                  {r.items.map(item => (
                    <div className="skincare-configuration-menu-block-item">
                      <div className="skincare-configuration-menu-block-item-img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="skincare-configuration-menu-block-item-text">
                        <div className="skincare-configuration-menu-block-item-title">
                          {item.title}
                        </div>
                        <div className="skincare-configuration-menu-block-item-desc">
                          {item.desc}
                        </div>
                        <div className="skincare-configuration-menu-block-item-button">
                          <button
                            className="btn btn-primary"
                            onClick={() => history.push(item.link)}
                          >
                            <Trans i18nKey="p.s.uiconfiguration.menu.config.button">
                              Config
                            </Trans>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
}
